module.exports = __webpack_public_path__ + "img/ddosAtacks.8385376.svg";